'use es6';

import { getTimestamp } from '../../common-message-format/operators/commonMessageFormatGetters';
export const areDifferentDays = (previousMessage, message) => {
  const dateA = new Date(getTimestamp(previousMessage));
  const dateB = new Date(getTimestamp(message));
  return dateA.getFullYear() !== dateB.getFullYear() || dateA.getMonth() !== dateB.getMonth() || dateA.getDate() !== dateB.getDate();
};